import React from 'react';

type Props = {
	load: () => Promise<{ default: React.ComponentType<unknown> }>;
	children: (cmp: React.ReactNode | null) => React.ReactNode;
};

type State = {
	component: React.ComponentType<unknown> | null;
};

export class DynamicImports extends React.Component<Props, State> {
	state = {
		component: null
	};

	componentDidMount() {
		this.props.load().then((mod) => this.setState(() => ({ component: mod.default })));
	}

	render() {
		return this.props.children(this.state.component);
	}
}
